// @TS72421 - Lazy loading images
import { Directive, Input, ElementRef, Renderer2, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import * as lazySizes from 'lazysizes';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
import { LocalStorageService} from 'ngx-webstorage';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[lazyload]',
  exportAs: 'lazyload',
  standalone:false
})

export class LazyLoadImageDirective implements OnInit {
  public tempImage = '/CRD/images/pixel.jpg';
  private _imgSrc: string;
  imagePrefix: any;
  @Input('lazyload')
  get imgSrc(): string {
    return this._imgSrc;
  }
  set imgSrc(src: string) {
    this._imgSrc = this.getImagePath(src);
    this.ngOnInit();
  }

  public img;
  private isBrowser: boolean;
  constructor(
    private el: ElementRef,
    private localStorage: LocalStorageService,
    private renderer: Renderer2,
    private mktEnvironmentService: MktEnvironmentService,
    @Inject(PLATFORM_ID) private _platformId: string,
    ) {
    this.isBrowser = isPlatformBrowser(this._platformId);
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }

  ngOnInit() {
    if(!this.isBrowser) return;
    if (this._imgSrc.includes('-lg') && window.innerWidth <= 599) {
      this._imgSrc = this._imgSrc.replace('-lg', '-sm');
    }

    this.initLazyLoading();
    this.setAttributes();
  }

  initLazyLoading() {
    if (lazySizes) {
      lazySizes.init();
    }
  }

  setAttributes() {
    this.renderer.addClass(this.el.nativeElement, 'lazyload');
    if (this.el.nativeElement.localName === 'img') {
      this.setImgSrc();
    } else {
      this.setElementBackgroundImage();
    }
  }

  setImgSrc() {
    const cachedImg = this.getWithExpiry(this.imgSrc);
    if(cachedImg){
      this.imgSrc = cachedImg;
    }
    this.renderer.setAttribute(this.el.nativeElement, 'src', `${this.imagePrefix}${this.tempImage}`);
    this.renderer.setAttribute(this.el.nativeElement, 'data-src', this.imgSrc);
    this.renderer.setAttribute(this.el.nativeElement, 'lazy', "true");
   // this.renderer.setAttribute(this.el.nativeElement, 'height', '1px');
   // this.renderer.setAttribute(this.el.nativeElement, 'width', '1px');
    // TS72421 - Removed the loader as a placeholder.
    // this.renderer.setAttribute(this.el.nativeElement, 'src', this.tempImage);
  }

  setElementBackgroundImage() {
    this.renderer.setAttribute(this.el.nativeElement, 'data-bg', this.imgSrc);
    // TS72421 - Removed the loader as a placeholder.
    // this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${this.tempImage})`);
  }

  getImagePath(src) {
    return `${src}`;
  }
  getWithExpiry(key) {
      const itemStr = this.localStorage.retrieve(key);
      // if the item doesn't exist, return null
      if (!itemStr) {
          return null;
      }
      const item = JSON.parse(itemStr || '{}');
      const now = new Date()
      // compare the expiry time of the item with the current time
      if (now.getTime() > item.expiry) {
          // If the item is expired, delete the item from storage
          // and return null
          this.localStorage.clear(key)
          return null
      }
      return item.value
  }

}
